import { supabase } from '../lib/supabase';

class QuestoesService {
  // Buscar todas as questões de um teste
  async getByTesteId(testeId) {
    try {
      const { data, error } = await supabase
        .from('teste_questoes')
        .select('*')
        .eq('teste_id', testeId)
        .eq('ativo', true)
        .order('ordem', { ascending: true });

      if (error) throw error;
      return data || [];
    } catch (error) {
      console.error('Erro ao buscar questões:', error);
      throw error;
    }
  }

  // Buscar questão por ID
  async getById(id) {
    try {
      const { data, error } = await supabase
        .from('teste_questoes')
        .select('*')
        .eq('id', id)
        .single();

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Erro ao buscar questão:', error);
      throw error;
    }
  }

  // Criar nova questão
  async create(questaoData) {
    try {
      // Buscar a próxima ordem disponível
      const { data: ultimaQuestao } = await supabase
        .from('teste_questoes')
        .select('ordem')
        .eq('teste_id', questaoData.teste_id)
        .order('ordem', { ascending: false })
        .limit(1)
        .single();

      const proximaOrdem = ultimaQuestao ? ultimaQuestao.ordem + 1 : 1;

      const { data, error } = await supabase
        .from('teste_questoes')
        .insert([{
          ...questaoData,
          ordem: proximaOrdem
        }])
        .select()
        .single();

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Erro ao criar questão:', error);
      throw error;
    }
  }

  // Atualizar questão
  async update(id, questaoData) {
    try {
      const { data, error } = await supabase
        .from('teste_questoes')
        .update(questaoData)
        .eq('id', id)
        .select()
        .single();

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Erro ao atualizar questão:', error);
      throw error;
    }
  }

  // Excluir questão
  async delete(id) {
    try {
      const { error } = await supabase
        .from('teste_questoes')
        .delete()
        .eq('id', id);

      if (error) throw error;
      return true;
    } catch (error) {
      console.error('Erro ao excluir questão:', error);
      throw error;
    }
  }

  // Reordenar questões
  async reorderQuestoes(questoes) {
    try {
      // Usar Promise.all para fazer múltiplas atualizações individuais
      const updatePromises = questoes.map((questao, index) => 
        supabase
          .from('teste_questoes')
          .update({ ordem: index + 1 })
          .eq('id', questao.id)
      );

      const results = await Promise.all(updatePromises);
      
      // Verificar se alguma atualização falhou
      const errors = results.filter(result => result.error);
      if (errors.length > 0) {
        throw new Error(`Erro em ${errors.length} atualizações: ${errors[0].error.message}`);
      }

      return true;
    } catch (error) {
      console.error('Erro ao reordenar questões:', error);
      throw error;
    }
  }

  // Duplicar questão
  async duplicate(id) {
    try {
      const questaoOriginal = await this.getById(id);
      
      const { id: _, ordem, created_at, updated_at, ...questaoData } = questaoOriginal;
      
      questaoData.questao = `${questaoData.questao} (Cópia)`;
      
      return await this.create(questaoData);
    } catch (error) {
      console.error('Erro ao duplicar questão:', error);
      throw error;
    }
  }

  // Ativar/Desativar questão
  async toggleActive(id, ativo) {
    try {
      const { data, error } = await supabase
        .from('teste_questoes')
        .update({ ativo })
        .eq('id', id)
        .select()
        .single();

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Erro ao alterar status da questão:', error);
      throw error;
    }
  }

  // Contar questões de um teste
  async countByTesteId(testeId) {
    try {
      const { count, error } = await supabase
        .from('teste_questoes')
        .select('*', { count: 'exact', head: true })
        .eq('teste_id', testeId)
        .eq('ativo', true);

      if (error) throw error;
      return count || 0;
    } catch (error) {
      console.error('Erro ao contar questões:', error);
      return 0;
    }
  }
}

export default new QuestoesService();
